import React from "react";
import CardContainer from "components/card/CardContainer";

const LessonCard = ({
  images,
  title,
  lessonClass,
  writer,
  subject,
  onClick,
}) => {
  return (
    <CardContainer
      title={title}
      subject={subject || "Ընդհանուր"}
      image={images.poster || images.cover}
      onClick={onClick}
      cardClass={lessonClass}
      content={
        <div className="flex flex-col gap-2 p-4 w-full text-black">
          <span className="text-[14px] font-[500] line-clamp-2">{title}</span>
          {writer && <span className="text-[16px] font-[500]">
            Հեղինակ՝ {writer}
          </span>}
        </div>
      }
    />
  );
};

export default LessonCard;
